module.exports = __webpack_public_path__ + "img/pic_11.0110df92.jpg";